import {
  createBehaviorSubject,
  useBehaviorSubjectValue,
} from 'utils/behaviorSubject';
import {
  COOKIES_CONSENT_STORAGE_KEY,
  TABLE_RESIZING_STORAGE_KEY,
} from 'utils/storage';

const readStoredConsent = (): boolean | undefined => {
  try {
    const storedConsent = localStorage.getItem(COOKIES_CONSENT_STORAGE_KEY);
    return storedConsent === null ? undefined : JSON.parse(storedConsent);
  } catch {
    return undefined;
  }
};

const consent$ = createBehaviorSubject<boolean | undefined>(
  readStoredConsent(),
);

const updateConsent = (consent: boolean) => {
  try {
    localStorage.setItem(COOKIES_CONSENT_STORAGE_KEY, JSON.stringify(consent));
    if (!consent) {
      localStorage.removeItem(TABLE_RESIZING_STORAGE_KEY);
    }
  } catch {
    // The browser can block storage. The choice then applies until a reload.
  }
  consent$.next(consent);
};

export const useCookiesConsent = () => ({
  nonEssentialCookiesApproved: useBehaviorSubjectValue(consent$, []),
  updateConsent,
});
